export const questionsConstants = {

    LOGOUT: 'USERS_LOGOUT',

    QUESTIONS_GETALL_REQUEST: 'QUESTIONS_GETALL_REQUEST',
    QUESTIONS_GETALL_SUCCESS: 'QUESTIONS_GETALL_SUCCESS',
    QUESTIONS_GETALL_FAILURE: 'QUESTIONS_GETALL_FAILURE',

    QUESTIONS_LIST_GETALL_REQUEST: 'QUESTIONS_LIST_GETALL_REQUEST',
    QUESTIONS_LIST_GETALL_SUCCESS: 'QUESTIONS_LIST_GETALL_SUCCESS',
    QUESTIONS_LIST_GETALL_FAILURE: 'QUESTIONS_LIST_GETALL_FAILURE',

    ANSWERS_SUBMIT_REQUEST: 'ANSWERS_SUBMIT_REQUEST',
    ANSWERS_SUBMIT_SUCCESS: 'ANSWERS_SUBMIT_SUCCESS',
    ANSWERS_SUBMIT_FAILURE: 'ANSWERS_SUBMIT_FAILURE',

    ANSWERS_ASSESSMENT_SUBMIT_REQUEST: 'ANSWERS_ASSESSMENT_SUBMIT_REQUEST',
    ANSWERS_ASSESSMENT_SUBMIT_SUCCESS: 'ANSWERS_ASSESSMENT_SUBMIT_SUCCESS',
    ANSWERS_ASSESSMENT_SUBMIT_FAILURE: 'ANSWERS_ASSESSMENT_SUBMIT_FAILURE',

    GET_LANGUAGE_LABEL_REQUEST: 'GET_LANGUAGE_LABEL_REQUEST',
    GET_LANGUAGE_LABEL_SUCCESS: 'GET_LANGUAGE_LABEL_SUCCESS',
    GET_LANGUAGE_LABEL_FAILURE: 'GET_LANGUAGE_LABEL_FAILURE',

    GET_SURVEY_TEMPLATE_CODE_REQUEST: 'GET_SURVEY_TEMPLATE_CODE_REQUEST',
    GET_SURVEY_TEMPLATE_CODE_SUCCESS: 'GET_SURVEY_TEMPLATE_CODE_SUCCESS',
    GET_SURVEY_TEMPLATE_CODE_FAILURE: 'GET_SURVEY_TEMPLATE_CODE_FAILURE',

    GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_REQUEST: 'GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_REQUEST',
    GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_SUCCESS: 'GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_SUCCESS',
    GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_FAILURE: 'GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_FAILURE',


    GET_EMPLOYEE_STATUS_REQUEST: 'GET_EMPLOYEE_STATUS_REQUEST',
    GET_EMPLOYEE_STATUS_SUCCESS: 'GET_EMPLOYEE_STATUS_SUCCESS',
    GET_EMPLOYEE_STATUS_FAILURE: 'GET_EMPLOYEE_STATUS_FAILURE',

    GET_SURVEY_TEMPLATE_SURVEY_CODE_REQUEST: 'GET_SURVEY_TEMPLATE_SURVEY_CODE_REQUEST',
    GET_SURVEY_TEMPLATE_SURVEY_CODE_SUCCESS: 'GET_SURVEY_TEMPLATE_SURVEY_CODE_SUCCESS',
    GET_SURVEY_TEMPLATE_SURVEY_CODE_FAILURE: 'GET_SURVEY_TEMPLATE_SURVEY_CODE_FAILURE',

    GET_RESPONDANT_NAME_REQUEST: 'GET_RESPONDANT_NAME_REQUEST',
    GET_RESPONDANT_NAME_SUCCESS: 'GET_RESPONDANT_NAME_SUCCESS',
    GET_RESPONDANT_NAME_FAILURE: 'GET_RESPONDANT_NAME_FAILURE',

    GET_ASSESSMENT_EMPLOYEE_DETAILS_REQUEST: 'GET_ASSESSMENT_EMPLOYEE_DETAILS_REQUEST',
    GET_ASSESSMENT_EMPLOYEE_DETAILS_SUCCESS: 'GET_ASSESSMENT_EMPLOYEE_DETAILS_SUCCESS',
    GET_ASSESSMENT_EMPLOYEE_DETAILS_FAILURE: 'GET_ASSESSMENT_EMPLOYEE_DETAILS_FAILURE',

    GET_ACCESSMENT_REPORT_REQUEST: 'GET_ACCESSMENT_REPORT_REQUEST',
    GET_ACCESSMENT_REPORT_SUCCESS: 'GET_ACCESSMENT_REPORT_SUCCESS',
    GET_ACCESSMENT_REPORT_FAILURE: 'GET_ACCESSMENT_REPORT_FAILURE',


    GET_ACCESSMENT_STATUS_REQUEST: 'GET_ACCESSMENT_STATUS_REQUEST',
    GET_ACCESSMENT_STATUS_SUCCESS: 'GET_ACCESSMENT_STATUS_SUCCESS',
    GET_ACCESSMENT_STATUS_FAILURE: 'GET_ACCESSMENT_STATUS_FAILURE',

    GET_TRANSLATE_ELEMENT_REQUEST: 'GET_TRANSLATE_ELEMENT_REQUEST',
    GET_TRANSLATE_ELEMENT_SUCCESS: 'GET_TRANSLATE_ELEMENT_SUCCESS',
    GET_TRANSLATE_ELEMENT_FAILURE: 'GET_TRANSLATE_ELEMENT_FAILURE',

    GET_SURVEY_DESIGN_BY_CODE_REQUEST: 'GET_SURVEY_DESIGN_BY_CODE_REQUEST',
    GET_SURVEY_DESIGN_BY_CODE_SUCCESS: 'GET_SURVEY_DESIGN_BY_CODE_SUCCESS',
    GET_SURVEY_DESIGN_BY_CODE_FAILURE: 'GET_SURVEY_DESIGN_BY_CODE_FAILURE',

    GET_EMP_DMG_VALUES_REQUEST: 'GET_EMP_DMG_VALUES_REQUEST',
    GET_EMP_DMG_VALUES_SUCCESS: 'GET_EMP_DMG_VALUES_SUCCESS',
    GET_EMP_DMG_VALUES_FAILURE: 'GET_EMP_DMG_VALUES_FAILURE',

    SAVE_SURVEY_CONSENT_REQUEST: 'SAVE_SURVEY_CONSENT_REQUEST',
    SAVE_SURVEY_CONSENT_SUCCESS: 'SAVE_SURVEY_CONSENT_SUCCESS',
    SAVE_SURVEY_CONSENT_FAILURE: 'SAVE_SURVEY_CONSENT_FAILURE',

    GET_PARA_CATEGORY_REQUEST: 'GET_PARA_CATEGORY_REQUEST',
    GET_PARA_CATEGORY_SUCCESS: 'GET_PARA_CATEGORY_SUCCESS',
    GET_PARA_CATEGORY_FAILURE: 'GET_PARA_CATEGORY_FAILURE',

    GET_LEADERSHIP_REPORT_SCORE_REQUEST: 'GET_LEADERSHIP_REPORT_SCORE_REQUEST',
    GET_LEADERSHIP_REPORT_SCORE_SUCCESS: 'GET_LEADERSHIP_REPORT_SCORE_SUCCESS',
    GET_LEADERSHIP_REPORT_SCORE_FAILURE: 'GET_LEADERSHIP_REPORT_SCORE_FAILURE',

    GET_LEADERSHIP_PARA_CATEGORY_REQUEST: 'GET_LEADERSHIP_PARA_CATEGORY_REQUEST',
    GET_LEADERSHIP_PARA_CATEGORY_SUCCESS: 'GET_LEADERSHIP_PARA_CATEGORY_SUCCESS',
    GET_LEADERSHIP_PARA_CATEGORY_FAILURE: 'GET_LEADERSHIP_PARA_CATEGORY_FAILURE',

    GET_LEADERSHIP_TEXT_DETAILS_REQUEST: 'GET_LEADERSHIP_TEXT_DETAILS_REQUEST',
    GET_LEADERSHIP_TEXT_DETAILS_SUCCESS: 'GET_LEADERSHIP_TEXT_DETAILS_SUCCESS',
    GET_LEADERSHIP_TEXT_DETAILS_FAILURE: 'GET_LEADERSHIP_TEXT_DETAILS_FAILURE',

    GET_INSIGHT_SURVEY_CODE_REQUEST: 'GET_INSIGHT_SURVEY_CODE_REQUEST',
    GET_INSIGHT_SURVEY_CODE_SUCCESS: 'GET_INSIGHT_SURVEY_CODE_SUCCESS',
    GET_INSIGHT_SURVEY_CODE_FAILURE: 'GET_INSIGHT_SURVEY_CODE_FAILURE',

    SAVE_CHEAT_LOGS_REQUEST: 'SAVE_CHEAT_LOGS_REQUEST',
    SAVE_CHEAT_LOGS_SUCCESS: 'SAVE_CHEAT_LOGS_SUCCESS',
    SAVE_CHEAT_LOGS_FAILURE: 'SAVE_CHEAT_LOGS_FAILURE',


    QUICK_SAVE_ANSWERS_REQUEST: 'QUICK_SAVE_ANSWERS_REQUEST',
    QUICK_SAVE_ANSWERS_SUCCESS: 'QUICK_SAVE_ANSWERS_SUCCESS',
    QUICK_SAVE_ANSWERS_FAILURE: 'QUICK_SAVE_ANSWERS_FAILURE',

    GET_LAST_SAVE_QUESTION_REQUEST: 'GET_LAST_SAVE_QUESTION_REQUEST',
    GET_LAST_SAVE_QUESTION_SUCCESS: 'GET_LAST_SAVE_QUESTION_SUCCESS',
    GET_LAST_SAVE_QUESTION_FAILURE: 'GET_LAST_SAVE_QUESTION_FAILURE',


    EMPTY_REDUCER: 'EMPTY_REDUCER',



};
